import PropTypes from 'prop-types';
import { Text, View } from '@react-pdf/renderer';

import styles from './Styles.js';

const NoData = ({ title }) =>
    <View style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} wrap={false}>
        <View style={styles.sheepContainer}>
            <View style={styles.sheepHeader}>
                <Text>{title}</Text>
            </View>
            <View style={styles.sheepContainerCell}>
                <View style={styles.sheepContainerHeaderText}>
                    <Text>{'Δεν υπάρχουν διαθέσιμες πληροφορίες'}</Text>
                </View>
            </View>
        </View>
    </View>;

export const SheepBoilerplate = ({ data, title }) => {
    if (data === null || typeof data === 'undefined') return <NoData title={title} />;

    return (
        <View style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} wrap={false}>
            <View style={styles.sheepContainer}>
                <View style={styles.sheepHeader}>
                    <Text>{title}</Text>
                </View>
                <View style={{ paddingTop: '4px', paddingBot: '4px' }}>
                    <View style={styles.sheepContainerCell}>
                        <View style={styles.sheepContainerHeaderText}>
                            <Text>{'Κωδικός Γενεολογικού Βιβλίου: '}</Text>
                        </View>
                        <View style={styles.sheepContainerCellText}>
                            <Text>{data?.registrationCode}</Text>
                        </View>
                    </View>
                    <View style={styles.sheepContainerCell}>
                        <View style={styles.sheepContainerHeaderText}>
                            <Text>{'Εκτροφή: '}</Text>
                        </View>
                        <View style={styles.sheepContainerCellText}>
                            {data?.owner
                                ? <Text>{`${data?.owner}`}</Text>
                                : <Text>{' '}</Text>
                            }
                        </View>
                    </View>
                    <View style={styles.sheepContainerCell}>
                        <View style={styles.sheepContainerHeaderText}>
                            <Text>{'Φύλο: '}</Text>
                        </View>
                        <View style={styles.sheepContainerCellText}>
                            <Text>{data?.sex}</Text>
                        </View>
                    </View>
                    <View style={styles.sheepContainerCell}>
                        <View style={styles.sheepContainerHeaderText}>
                            <Text>{'Φυλή: '}</Text>
                        </View>
                        <View style={styles.sheepContainerCellText}>
                            <Text>{data?.breedCode}</Text>
                        </View>
                    </View>
                    <View style={styles.sheepContainerCell}>
                        <View style={styles.sheepContainerHeaderText}>
                            <Text>{'Ημ/νία Γέννησης: '}</Text>
                        </View>
                        <View style={styles.sheepContainerCellText}>
                            <Text>{data?.birthDate ? new Date(data.birthDate).toLocaleDateString("el-GR") : ''}</Text>
                        </View>
                    </View>
                    <View style={styles.sheepContainerCell}>
                        <View style={styles.sheepContainerHeaderText}>
                            <Text>{'Απομάκρυνση: '}</Text>
                        </View>
                        <View style={styles.sheepContainerCellText}>
                            <Text>{data?.cullingCode}</Text>
                        </View>
                    </View>
                    <View style={styles.sheepContainerCell}>
                        <View style={styles.sheepContainerHeaderText}>
                            <Text>{'Ημ/νία Απομάκρυνσης: '}</Text>
                        </View>
                        <View style={styles.sheepContainerCellText}>
                            <Text>{data?.cullingDate ? new Date(data.cullingDate).toLocaleDateString("el-GR") : ''}</Text>
                        </View>
                    </View>
                </View>
            </View>
        </View>
    );
};

SheepBoilerplate.propTypes = {
    data: PropTypes.object,
    title: PropTypes.string,
};

NoData.propTypes = {
    title: PropTypes.string,
};

